import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-fit-to-screen",
  "use": "icon-fit-to-screen-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-fit-to-screen\"><path d=\"M1 4h1v8H1zm13 0h1v8h-1zm-3.8 1.2-.7.7 1.6 1.6H4.9l1.6-1.6-.7-.7L3 8l2.8 2.8.7-.7-1.6-1.6h6.2l-1.6 1.6.7.7L13 8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol